import React, {useRef, useState} from "react";
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    EditButton,
    RichTextField,
    ArrayField,
    useTranslate,
    Pagination,
    TextInput,
    NumberInput,
    BooleanInput,
} from 'react-admin';
import {useReactToPrint} from "react-to-print";
import {BoxedShowLayout, RaBox} from 'ra-compact-ui'
import {
    ListBulkActions,
    AddressField,
    AddressFields,
    ListActions,
    useExpandOnlyOne,
    SingleFieldList,
} from "../../components";
import {Divider} from '@mui/material';
import {Button, InputAdornment, TextField as TextFieldMUI} from "@material-ui/core";
import {Exporter} from "../../data/export";
import {partnerAddressAdditionalInfo} from "./utils";
import {HiddenAddressPrintGrid} from "../../components/AddressQR";
import QrCode2Icon from '@mui/icons-material/QrCode2';


const AllFields = (props) => {
    const translate = useTranslate();

    return <BoxedShowLayout {...props}>
        <RaBox display="flex" justifyContent="space-between">
            <RaBox>
                <TextField source="shortName"/>
                <TextField source="phoneNumber"/>
                <TextField source="email"/>
                <BooleanField source="contractor"/>
            </RaBox>
            <RaBox>
                <TextField source="name"/>
                <TextField source="ico"/>
                <TextField source="dic"/>
                <TextField source="representative"/>
            </RaBox>
            <RaBox>
                {AddressFields}
            </RaBox>
            <RaBox>
                <TextField source="bankName"/>
                <TextField source="bankAccount"/>
                <RichTextField source="note"/>
            </RaBox>
            <RaBox>
                <div/>
            </RaBox>
        </RaBox>
        <Divider/>
        <ArrayField source='addresses' label='resources.partners.fields.addresses.name'>
            <SingleFieldList emptyText={translate('resources.partners.fields.addresses.empty')}>
                <PartnerAddressField/>
            </SingleFieldList>
        </ArrayField>
    </BoxedShowLayout>
};

const PartnerAddressField = props => {
    const {record} = props;
    const translate = useTranslate();

    return (
        <RaBox>
            <AddressField source='address' {...props}/>
            <span style={{
                marginLeft: '20px',
                color: 'rgba(0, 0, 0, 0.47)'
            }}>{partnerAddressAdditionalInfo(translate, record)}</span>
        </RaBox>
    )
};

const partnerFilters = [
    <TextInput
        source="shortName"
        label="resources.partners.filters.shortName"
    />,
    <NumberInput
        source="ico"
        label="resources.partners.filters.ico"
    />,
    <BooleanInput
        defaultValue={false}
        source="contractor"
        label="resources.partners.filters.contractor"
    />,
];

const PartnerList = ({permissions, ...props}) => {
    const translate = useTranslate();
    const printRef = useRef(null);
    const [qrSize, setQrSize] = useState()

    useExpandOnlyOne(props.resource, props.location);

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        pageStyle: `
            @media print {
                body {
                    margin: 10mm;
                }
            }
        `
    });

    const PrintQRButton = () => {
        return <span>
            <TextFieldMUI
                label={translate("app.message.qr_size")}
                type="number"
                defaultValue={qrSize}
                onChange={e => {
                    setQrSize(e?.target?.value);
                    localStorage.setItem("qrSize", e?.target?.value);
                }}
                style={{width: 200, marginLeft: 16, marginTop: -5}}
                variant="outlined"
                size="small"
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <span style={{ marginRight: 4 }}>cm</span>
                            <Button size="small" onClick={handlePrint}>
                                <QrCode2Icon/>
                            </Button>
                        </InputAdornment>
                    ),
                }}
            />
        </span>
    };

    return <List
        {...props}
        actions={<ListActions filter customButton={<PrintQRButton/>}/>}
        filters={partnerFilters}
        bulkActionButtons={<ListBulkActions permissions={permissions}/>}
        exporter={Exporter(translate, 'partners')}
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]}/>}
        perPage={50}
    >
        <div>
            <HiddenAddressPrintGrid printRef={printRef} qrSize={qrSize}/>
            <Datagrid
                rowClick="expand"
                expand={<AllFields {...props}/>}
            >
                {/*<TextField source="id"/>*/}
                <TextField source="shortName"/>
                <AddressField source="address" label='app.address.title'/>
                <TextField source="ico"/>
                <BooleanField source="contractor"/>
                <EditButton basePath="/partners"/>
            </Datagrid>
        </div>
    </List>
};


export default PartnerList;